import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import {
  Box,
  Breadcrumbs,
  Card,
  Fade,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Slider,
  Stack,
  useTheme
} from "@mui/material";
import { AlertDialog } from "../../AlertDialog";
import { ShelvingRepresentation } from "../ShelvingRepresentation";
import { IShelving } from "../../../hooks/shelvings";
import { strings } from "../../../localization/LocalizedStrings";
import { IShelf } from "../../../hooks/shelves";
import { IShelfSegment, IShelfSegmentAlbum } from "../../../hooks/shelfSegments";
import { ModifyShelvingDialog } from "../ModifyShelvingDialog";
import { useDeleteShelving } from "../../../hooks/shelvings/useDeleteShelving";
import { StatusCodesHelper } from "../../../models/StatusCodesHelper";
import { toast } from "react-toastify";
import { ModifyShelfDialog } from "../ModifyShelfDialog";
import { useDeleteShelf } from "../../../hooks/shelves/useDeleteShelf";
import { ModifyShelfSegmentDialog } from "../ModifyShelfSegmentDialog";
import { useDeleteShelfSegment } from "../../../hooks/shelfSegments/useDeleteShelfSegment";
import { ContentUnavailableNotice } from "../../attributes/ContentUnavailableNotice";
import { LayoutStatsButton } from "../LayoutStats";
import { useGetShelving } from "../../../hooks/shelvings/useGetShelving";
import { productIconMap } from "../../../models/ProductUtilities";
import { ProductType } from "../../../hooks/products/interfaces";
import { ShelvingSelectItem } from "../ShelvingSelectItem";
import { NewSelectItem } from "../NewSelectItem";
import { NoneSelectItem } from "../NoneSelectItem";
import { ShelfSelectItem } from "../ShelfSelectItem";
import { StringFormat } from "../../../models/StringFormat";
import { Icon, IconType } from "../../../icons";
import { useIsMobile } from "../../../hooks/isMobile";

export const LayoutDetail: FunctionComponent<ILayoutDetailProps> = ({
  shelvings,
  setShelvings,
  selectedAlbumIds,
  isLoading,
  setIsLoading,
  onShelfSegmentAlbumSelected,
  onAssignAlbumsToShelfSegmentByFilter,
  onRemoveAlbumFromShelfSegment,
  onSelectedShelving,
  overrideShelving,
  onShelfSegmentFetched
}) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const { getShelving } = useGetShelving();
  const { deleteShelving } = useDeleteShelving();
  const { deleteShelf } = useDeleteShelf();
  const { deleteShelfSegment } = useDeleteShelfSegment();
  const [isLoadingShelving, setIsLoadingShelving] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertIsOpen, setAlertIsOpen] = useState(false);
  const [isAddShelvingDialogOpen, setIsAddShelvingDialogOpen] = useState(false);
  const [isModifyShelvingDialogOpen, setIsModifyShelvingDialogOpen] = useState(false);
  const [isModifyShelfDialogOpen, setIsModifyShelfDialogOpen] = useState(false);
  const [isModifyShelfSegmentDialogOpen, setIsModifyShelfSegmentDialogOpen] = useState(false);
  const [isDeleteShelvingAlertOpen, setIsDeleteShelvingAlertOpen] = useState(false);
  const [isDeleteShelfAlertOpen, setIsDeleteShelfAlertOpen] = useState(false);
  const [isDeleteShelfSegmentAlertOpen, setIsDeleteShelfSegmentAlertOpen] = useState(false);
  const [isAddShelfDialogOpen, setIsAddShelfDialogOpen] = useState(false);
  const [isAddShelfSegmentDialogOpen, setIsAddShelfSegmentDialogOpen] = useState(false);
  const [selectedShelving, setSelectedShelving] = useState<IShelving>();
  const [selectedShelf, setSelectedShelf] = useState<IShelf>();
  const [selectedShelfSegment, setSelectedShelfSegment] = useState<IShelfSegment>();
  const [refreshSelects, setRefreshSelects] = useState(false);
  const [isShelvingSelectOpen, setIsShelvingSelectOpen] = useState(false);
  const [isShelfSelectOpen, setIsShelfSelectOpen] = useState(false);
  const [isShelfSegmentSelectOpen, setIsShelfSegmentSelectOpen] = useState(false);
  const [activeShelving, setActiveShelving] = useState<IShelving>(null);
  const [activeShelf, setActiveShelf] = useState<IShelf>(null);
  const [activeShelfSegment, setActiveShelfSegment] = useState<IShelfSegment>(null);
  const [zoom, setZoom] = useState(0.5);
  useEffect(() => {
    if (!refreshSelects) return;
    setTimeout(() => setRefreshSelects(false), 100);
  }, [refreshSelects]);
  useEffect(() => {
    if (shelvings && shelvings.length > 0 && selectedShelving) {
      const newShelving = shelvings.filter(shelving => shelving.uuid == selectedShelving.uuid)[0];
      setSelectedShelving(newShelving);
      if (selectedShelf) {
        const newShelf = selectedShelving.shelves.filter(
          shelf => shelf.uuid == selectedShelf.uuid
        )[0];
        setSelectedShelf(newShelf);
        if (selectedShelfSegment) {
          const newSegment = selectedShelf.segments.filter(
            segment => segment.uuid == selectedShelfSegment.uuid
          )[0];
          setSelectedShelfSegment(newSegment);
        }
      }
    }
  }, [shelvings]);
  useEffect(() => {
    onSelectedShelving(selectedShelving);
  }, [selectedShelving]);
  useEffect(() => {
    if (overrideShelving && overrideShelving.shelves === undefined) {
      getShelvingDetail(overrideShelving.uuid).then();
    }
  }, [overrideShelving]);
  const onShelvingUpdated = (newShelving: IShelving) => {
    if (shelvings.map(shelving => shelving.uuid).includes(newShelving.uuid)) {
      setShelvings(
        shelvings.map(shelving => {
          if (shelving.uuid != newShelving.uuid) return shelving;
          newShelving.shelves = shelving.shelves;
          return newShelving;
        })
      );
    } else {
      setShelvings([...shelvings, newShelving]);
    }
  };
  const onShelfUpdated = (newShelf: IShelf) => {
    if (selectedShelving?.shelves.map(shelf => shelf.uuid).includes(newShelf.uuid)) {
      setShelvings(
        shelvings.map(auxShelving => {
          if (auxShelving.uuid == selectedShelving.uuid) {
            auxShelving.shelves = auxShelving.shelves.map(auxShelf => {
              if (auxShelf.uuid != newShelf.uuid) return auxShelf;
              newShelf.segments = auxShelf.segments;
              return newShelf;
            });
          }
          return auxShelving;
        })
      );
    } else {
      setShelvings(
        shelvings.map(auxShelving => {
          if (auxShelving.uuid == selectedShelving.uuid) {
            auxShelving.shelves.push(newShelf);
          }
          return auxShelving;
        })
      );
    }
  };
  const onShelfSegmentUpdated = (shelf: IShelf, newShelfSegment: IShelfSegment) => {
    if (selectedShelf?.segments.map(segment => segment.uuid).includes(newShelfSegment.uuid)) {
      setShelvings(
        shelvings.map(auxShelving => {
          if (auxShelving.uuid == selectedShelving.uuid) {
            auxShelving.shelves = auxShelving.shelves.map(auxShelf => {
              if (auxShelf.uuid == shelf.uuid) {
                auxShelf.segments = auxShelf.segments.map(segment =>
                  segment.uuid == newShelfSegment.uuid ? newShelfSegment : segment
                );
              }
              return auxShelf;
            });
          }
          return auxShelving;
        })
      );
    } else {
      setShelvings(
        shelvings.map(shelving => {
          if (shelving.uuid == selectedShelving.uuid) {
            shelving.shelves = shelving.shelves.map(shelf => {
              if (shelf.uuid == selectedShelf.uuid) {
                shelf.segments.push(newShelfSegment);
              }
              return shelf;
            });
          }
          return shelving;
        })
      );
    }
  };
  const getShelvingDetail = async (uuid: string) => {
    setIsLoading(true);
    setIsLoadingShelving(true);
    const { status, body } = await getShelving(uuid);
    if (StatusCodesHelper.isSuccessful(status)) {
      setShelvings(shelvings.map(shelving => (shelving.uuid == body.uuid ? body : shelving)));
      setSelectedShelving(body);
      setSelectedShelf(undefined);
      setSelectedShelfSegment(undefined);
      setRefreshSelects(true);
    } else {
      setAlertMessage(body.message);
      setAlertIsOpen(true);
    }
    setIsLoading(false);
    setIsLoadingShelving(false);
  };
  const removeShelving = async (shelving: IShelving) => {
    setIsLoading(true);
    const { status, body } = await deleteShelving({ uuid: shelving.uuid });
    if (StatusCodesHelper.isSuccessful(status)) {
      toast.success(strings.generic_update_success);
      if (selectedShelving.uuid === shelving.uuid) {
        setSelectedShelving(undefined);
        setSelectedShelf(undefined);
        setSelectedShelfSegment(undefined);
        setRefreshSelects(true);
      }
      setShelvings(shelvings.filter(auxShelving => auxShelving.uuid != shelving.uuid));
    } else {
      setAlertMessage(body.message);
      setAlertIsOpen(true);
    }
    setIsLoading(false);
  };
  const removeShelf = async (shelf: IShelf) => {
    setIsLoading(true);
    const { status, body } = await deleteShelf({ uuid: shelf.uuid });
    if (StatusCodesHelper.isSuccessful(status)) {
      toast.success(strings.generic_update_success);
      setShelvings(
        shelvings.map(shelving => {
          if (shelving.uuid == selectedShelving.uuid) {
            shelving.shelves = shelving.shelves.filter(auxShelf => auxShelf.uuid != shelf.uuid);
          }
          return shelving;
        })
      );
      setSelectedShelf(undefined);
      setSelectedShelfSegment(undefined);
      setRefreshSelects(true);
    } else {
      setAlertMessage(body.message);
      setAlertIsOpen(true);
    }
    setIsLoading(false);
  };
  const removeShelfSegment = async (shelf: IShelf, shelfSegment: IShelfSegment) => {
    setIsLoading(true);
    const { status, body } = await deleteShelfSegment({ uuid: shelfSegment.uuid });
    if (StatusCodesHelper.isSuccessful(status)) {
      toast.success(strings.generic_update_success);
      setShelvings(
        shelvings.map(auxShelving => {
          if (auxShelving.uuid == selectedShelving.uuid) {
            auxShelving.shelves.map(auxShelf => {
              if (auxShelf.uuid == shelf.uuid) {
                auxShelf.segments = auxShelf.segments.filter(
                  segment => segment.uuid != shelfSegment.uuid
                );
              }
              return auxShelf;
            });
          }
          return auxShelving;
        })
      );
      setSelectedShelfSegment(undefined);
      setRefreshSelects(true);
    } else {
      setAlertMessage(body.message);
      setAlertIsOpen(true);
    }
    setIsLoading(false);
  };
  return (
    <div className={styles.mainContainer}>
      <Card
        className={styles.breadcrumbDiv}
        style={{ backgroundColor: theme.palette.background.default }}
      >
        <Stack className={styles.breadcrumbStack} direction={"row"}>
          <Breadcrumbs className={styles.breadcrumb} separator={"•"}>
            {!refreshSelects && (
              <div className={styles.breadcrumbElement}>
                <FormControl sx={{ minWidth: "140px" }} disabled={isLoading}>
                  <InputLabel size={"small"} id={"shelving-label"} sx={{ pointerEvents: "none" }}>
                    {strings.shelving_title}
                  </InputLabel>
                  <Select
                    open={isShelvingSelectOpen}
                    onOpen={() => setIsShelvingSelectOpen(true)}
                    onClose={() => setIsShelvingSelectOpen(false)}
                    size={"small"}
                    labelId={"shelving-label"}
                    value={selectedShelving?.uuid ?? ""}
                    label={strings.shelving_title}
                    renderValue={() => (
                      <p className={styles.breadcrumbText}>{selectedShelving?.name}</p>
                    )}
                    onChange={async event => {
                      const shelving = shelvings.filter(
                        shelving => shelving.uuid == event.target.value
                      )[0];
                      if (shelving?.shelves !== undefined) {
                        setSelectedShelf(undefined);
                        setSelectedShelfSegment(undefined);
                        setSelectedShelving(shelving);
                        setRefreshSelects(true);
                      } else if (shelving) {
                        await getShelvingDetail(shelving.uuid);
                      } else {
                        setSelectedShelving(undefined);
                        setSelectedShelf(undefined);
                        setSelectedShelfSegment(undefined);
                        setRefreshSelects(true);
                      }
                    }}
                  >
                    <MenuItem key={"shelving_none"}>
                      <NoneSelectItem />
                    </MenuItem>
                    {shelvings.map(shelving => (
                      <ShelvingSelectItem
                        shelving={shelving}
                        onModify={() => {
                          setActiveShelving(shelving);
                          setIsModifyShelvingDialogOpen(true);
                        }}
                        onDelete={() => {
                          setActiveShelving(shelving);
                          setIsDeleteShelvingAlertOpen(true);
                        }}
                        setIsSelectOpen={setIsShelvingSelectOpen}
                        key={shelving.uuid}
                        value={shelving.uuid}
                      />
                    ))}
                    <NewSelectItem
                      key={"shelving_new"}
                      onClickCapture={event => {
                        setIsAddShelvingDialogOpen(true);
                        event.stopPropagation();
                        event.preventDefault();
                      }}
                    />
                  </Select>
                </FormControl>
              </div>
            )}
            {selectedShelving && !refreshSelects && (
              <div className={styles.breadcrumbElement}>
                <FormControl sx={{ minWidth: "140px" }} disabled={isLoading}>
                  <InputLabel size={"small"} id={"shelf-label"} sx={{ pointerEvents: "none" }}>
                    {strings.shelf_title}
                  </InputLabel>
                  <Select
                    open={isShelfSelectOpen}
                    onOpen={() => setIsShelfSelectOpen(true)}
                    onClose={() => setIsShelfSelectOpen(false)}
                    size={"small"}
                    labelId={"shelf-label"}
                    value={selectedShelf?.uuid ?? ""}
                    label={strings.shelf_title}
                    renderValue={() => (
                      <p className={styles.breadcrumbText}>{selectedShelf?.name}</p>
                    )}
                    onChange={event => {
                      const shelf = selectedShelving.shelves?.filter(
                        shelf => shelf.uuid == event.target.value
                      )[0];
                      setSelectedShelfSegment(undefined);
                      setSelectedShelf(shelf);
                      setRefreshSelects(true);
                    }}
                  >
                    <MenuItem key={"shelf_none"}>
                      <NoneSelectItem />
                    </MenuItem>
                    {selectedShelving.shelves
                      ?.sort((a, b) => a.order - b.order)
                      .map((shelf, index) => (
                        <ShelfSelectItem
                          name={shelf.name}
                          index={index + 1}
                          key={shelf.uuid}
                          value={shelf.uuid}
                          setIsSelectOpen={setIsShelfSelectOpen}
                          onDelete={() => {
                            setActiveShelf(shelf);
                            setIsDeleteShelfAlertOpen(true);
                          }}
                          onModify={() => {
                            setActiveShelf(shelf);
                            setIsModifyShelfDialogOpen(true);
                          }}
                        />
                      ))}
                    <NewSelectItem
                      key={"shelf_new"}
                      onClickCapture={event => {
                        setIsAddShelfDialogOpen(true);
                        event.stopPropagation();
                        event.preventDefault();
                      }}
                    />
                  </Select>
                </FormControl>
              </div>
            )}
            {selectedShelf && !refreshSelects && (
              <div className={styles.breadcrumbElement}>
                <FormControl sx={{ minWidth: "140px" }} disabled={isLoading}>
                  <InputLabel
                    size={"small"}
                    id={"shelf-segment-label"}
                    sx={{ pointerEvents: "none" }}
                  >
                    {strings.shelf_segment_title}
                  </InputLabel>
                  <Select
                    open={isShelfSegmentSelectOpen}
                    onOpen={() => setIsShelfSegmentSelectOpen(true)}
                    onClose={() => setIsShelfSegmentSelectOpen(false)}
                    size={"small"}
                    labelId={"shelf-segment-label"}
                    value={selectedShelfSegment?.uuid ?? ""}
                    label={strings.shelf_segment_title}
                    renderValue={() => (
                      <p className={styles.breadcrumbText}>{selectedShelfSegment?.name}</p>
                    )}
                    onChange={event => {
                      const shelfSegment = selectedShelf.segments?.filter(
                        shelfSegment => shelfSegment.uuid == event.target.value
                      )[0];
                      setSelectedShelfSegment(shelfSegment);
                    }}
                  >
                    <MenuItem key={"segment_none"}>
                      <NoneSelectItem />
                    </MenuItem>
                    {selectedShelf.segments
                      ?.sort((a, b) => a.order - b.order)
                      .map((shelfSegment, index) => (
                        <ShelfSelectItem
                          name={shelfSegment.name}
                          index={index + 1}
                          key={shelfSegment.uuid}
                          value={shelfSegment.uuid}
                          setIsSelectOpen={setIsShelfSegmentSelectOpen}
                          onDelete={() => {
                            setActiveShelfSegment(shelfSegment);
                            setIsDeleteShelfSegmentAlertOpen(true);
                          }}
                          onModify={() => {
                            setActiveShelfSegment(shelfSegment);
                            setActiveShelf(selectedShelf);
                            setIsModifyShelfSegmentDialogOpen(true);
                          }}
                        />
                      ))}
                    <NewSelectItem
                      key={"segment_new"}
                      onClickCapture={event => {
                        setIsAddShelfSegmentDialogOpen(true);
                        event.stopPropagation();
                        event.preventDefault();
                      }}
                    />
                  </Select>
                </FormControl>
              </div>
            )}
          </Breadcrumbs>
        </Stack>
        {selectedShelving && (
          <Stack className={styles.statsStack} direction={"column"} spacing={1}>
            <Box className={styles.zoomSlider}>
              <Stack spacing={1} direction={"row"} alignItems={"center"}>
                <Icon type={IconType.ZoomIn} />
                <Slider
                  value={zoom}
                  min={0.23}
                  max={1.2}
                  step={0.01}
                  onChange={(event, newValue) => setZoom(newValue as number)}
                />
              </Stack>
            </Box>
            {!isMobile && (
              <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <p
                  className={styles.tutorialText}
                  style={{ color: theme.palette.primary.subtitle }}
                >
                  {strings.shelving_tutorial}
                </p>
                <LayoutStatsButton
                  shelving={selectedShelving}
                  shelf={selectedShelf}
                  shelfSegment={selectedShelfSegment}
                />
              </Stack>
            )}
          </Stack>
        )}
      </Card>
      {isLoadingShelving ? (
        <Card
          className={styles.loadingContainer}
          style={{ backgroundColor: theme.palette.background.default }}
        >
          <Fade in unmountOnExit style={{ transitionDelay: "2000ms" }}>
            <Stack className={styles.loadingStack} spacing={3}>
              <p>{strings.stats_loading}</p>
              <LinearProgress className={styles.progressBar} variant={"indeterminate"} />
            </Stack>
          </Fade>
        </Card>
      ) : (
        <Card
          className={styles.shelvingContainer}
          style={{ backgroundColor: theme.palette.background.default }}
        >
          {selectedShelving ? (
            <div className={styles.shelving}>
              <ShelvingRepresentation
                shelving={selectedShelving}
                shelvings={shelvings}
                setShelvings={setShelvings}
                selectedShelf={selectedShelf}
                selectedShelfSegment={selectedShelfSegment}
                selectedAlbumIds={selectedAlbumIds}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                onShelfSegmentAlbumSelected={onShelfSegmentAlbumSelected}
                onRemoveAlbumFromShelfSegment={onRemoveAlbumFromShelfSegment}
                onShelfSegmentFetched={onShelfSegmentFetched}
                shelvingIndex={shelvings
                  .map(shelving => shelving.uuid)
                  .indexOf(selectedShelving.uuid)}
                zoom={zoom}
                onModifyShelving={shelving => {
                  setActiveShelving(shelving);
                  setIsModifyShelvingDialogOpen(true);
                }}
                onModifyShelf={shelf => {
                  setActiveShelf(shelf);
                  setIsModifyShelfDialogOpen(true);
                }}
                onModifyShelfSegment={(shelf, shelfSegment) => {
                  setActiveShelf(shelf);
                  setActiveShelfSegment(shelfSegment);
                  setIsModifyShelfSegmentDialogOpen(true);
                }}
                onFocus={(shelf, segment) => {
                  setSelectedShelf(shelf);
                  setSelectedShelfSegment(segment);
                }}
                onAssignAlbumsToShelfSegmentByFilter={onAssignAlbumsToShelfSegmentByFilter}
                isMinimalist={false}
              />
            </div>
          ) : (
            <div className={styles.contentUnavailable}>
              <ContentUnavailableNotice
                isLoading={false}
                items={selectedShelving ? undefined : []}
                defaultVisible
                emptyIconType={productIconMap[ProductType.SHELVINGS]}
                emptyTitle={strings.empty_shelvings}
                emptyDescription={strings.empty_shelvings_subtitle}
                addButtonTitle={strings.add_attribute}
                searchText={undefined}
                onAddItem={() => setIsAddShelvingDialogOpen(true)}
                canAdd
              />
            </div>
          )}
        </Card>
      )}
      <ModifyShelvingDialog
        open={isAddShelvingDialogOpen}
        setOpen={setIsAddShelvingDialogOpen}
        callback={onShelvingUpdated}
      />
      <ModifyShelvingDialog
        open={isModifyShelvingDialogOpen}
        setOpen={setIsModifyShelvingDialogOpen}
        shelving={activeShelving}
        onDelete={() => setIsDeleteShelvingAlertOpen(true)}
        callback={onShelvingUpdated}
      />
      <ModifyShelfDialog
        open={isAddShelfDialogOpen}
        setOpen={setIsAddShelfDialogOpen}
        callback={onShelfUpdated}
        shelving={selectedShelving}
      />
      <ModifyShelfDialog
        open={isModifyShelfDialogOpen}
        setOpen={setIsModifyShelfDialogOpen}
        shelving={selectedShelving}
        shelf={activeShelf}
        callback={onShelfUpdated}
        onDelete={() => setIsDeleteShelfAlertOpen(true)}
      />
      <ModifyShelfSegmentDialog
        open={isAddShelfSegmentDialogOpen}
        setOpen={setIsAddShelfSegmentDialogOpen}
        callback={shelfSegment => onShelfSegmentUpdated(selectedShelf, shelfSegment)}
        shelf={selectedShelf}
      />
      <ModifyShelfSegmentDialog
        open={isModifyShelfSegmentDialogOpen}
        setOpen={setIsModifyShelfSegmentDialogOpen}
        shelf={activeShelf}
        shelfSegment={activeShelfSegment}
        callback={shelfSegment => onShelfSegmentUpdated(activeShelf, shelfSegment)}
        onDelete={() => setIsDeleteShelfSegmentAlertOpen(true)}
      />
      <AlertDialog
        isConfirm={true}
        message={StringFormat(strings.shelving_delete_confirmation, activeShelving?.name ?? "")}
        open={isDeleteShelvingAlertOpen}
        setOpen={setIsDeleteShelvingAlertOpen}
        onConfirm={async () => {
          setIsModifyShelvingDialogOpen(false);
          await removeShelving(activeShelving);
        }}
      />
      <AlertDialog
        isConfirm={true}
        message={StringFormat(strings.shelf_delete_confirmation, activeShelf?.name ?? "")}
        open={isDeleteShelfAlertOpen}
        setOpen={setIsDeleteShelfAlertOpen}
        onConfirm={async () => {
          setIsModifyShelfDialogOpen(false);
          await removeShelf(activeShelf);
        }}
      />
      <AlertDialog
        isConfirm={true}
        message={StringFormat(
          strings.shelf_segment_delete_confirmation,
          activeShelfSegment?.name ?? "",
          activeShelf?.name ?? ""
        )}
        open={isDeleteShelfSegmentAlertOpen}
        setOpen={setIsDeleteShelfSegmentAlertOpen}
        onConfirm={async () => {
          setIsModifyShelfSegmentDialogOpen(false);
          await removeShelfSegment(activeShelf, activeShelfSegment);
        }}
      />
      <AlertDialog message={alertMessage} open={alertIsOpen} setOpen={setAlertIsOpen} />
    </div>
  );
};

export interface ILayoutDetailProps {
  shelvings: IShelving[];
  setShelvings: (shelvings: IShelving[]) => void;
  selectedAlbumIds: string[];
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  onShelfSegmentAlbumSelected: (shelfSegmentAlbum: IShelfSegmentAlbum) => void;
  onAssignAlbumsToShelfSegmentByFilter: (shelfSegment: IShelfSegment) => void;
  onRemoveAlbumFromShelfSegment: (
    shelfSegmentAlbum: IShelfSegmentAlbum,
    shelvingIndex: number,
    shelfIndex: number,
    shelfSegmentIndex: number,
    albumIndex: number
  ) => void;
  onShelfSegmentFetched: (
    shelfSegment: IShelfSegment,
    shelvingIndex: number,
    shelfIndex: number,
    shelfSegmentIndex: number
  ) => void;
  onSelectedShelving: (shelving: IShelving) => void;
  overrideShelving: IShelving | undefined;
}
